import React from 'react'
import { Container } from './styles'

const LoginLayout = ({ children }: any): JSX.Element => (
  <Container>
    {children}
  </Container>
)

export default LoginLayout
